/**
 * Created by aheshperera
 * 12/3/18
 * */

/**
 * React Modules
 */
import { combineReducers } from 'redux';
/**
 * Custom Reducers
 */
import bisFileReducer from './bisFileReducer';
import cookieReducer from './cookieReducer';
import fileTransferDetailsReducer from './fileTransferDetailsReducer';
import loaderReducer from './loaderReducer';
import vendorFileReducer from './vendorFileReducer';
import successReducer from './successReducer';
import errorReducer from './errorReducer';
import filesLogReducer from './filesLogReducer';
import userReducer from './userReducer';
import reportsLogReducer from './reportsLogReducer';
import usersReducer from './usersReducer';
import userProfileReducer from './userProfileReducer';
import userAssociationReducer from './userAssociationReducer';
import userGroupReducer from './userGroupReducer';
import vendorAssociationFileImportReducer from './vendorAssociationFileImportReducer';
import agreementFileReducer from './agreementFileReducer';
import vendorDataReducer from './vendorDataReducer';
import vendorFilterDataReducer from './vendorFilterDataReducer';
import costAuditDataReducer from './costAuditDataReducer';
import reportSupplementaryDataReducer from './reportSupplementaryDataReducer';
import contactUsReducer from './contactUsReducer';
import helpTopicsReducer from './helpTopicsReducer';
import recentActivityReducer from './recentActivityReducer';
import adhocCostDataReducer from './adhocCostDataReducer';
import requestDataReducer from './requestDataReducer';
import workspaceSearchReducer from './workspaceSearchReducer';
import enterpriseCostReducer from './enterpriseCostReducer';
import agreementDataReducer from './agreementDataReducer';
import agreementSearchDataReducer from './agreementSearchDataReducer';
import utilitiesReducer from './utilitiesReducer';
import secretsReducer from './secretsReducer';
import segmentDataReducer from './segmentDataReducer';
import formulaGroupReducer from './formulaGroupReducer';
import vendorBasesReducer from './vendorBasesReducer';
import businessCentersReducer from './businessCentersReducer';
import sasFDDataReducer from './sasFDDataReducer';
import massItemUploadReducer from './massItemUploadReducer';
import searchDataReducer from './searchDataReducer';
import costViewReducer from './costViewReducer';
import costImpactTermDataReducer from './costImpactTermDataReducer';
import priceModuleDataReducer from './priceModuleDataReducer';
import priceModuleFilterReducer from './priceModuleFilterReducer';

const rootReducer = combineReducers({
  fileReducer: bisFileReducer,
  fileTransferDetailsReducer,
  loaderReducer,
  cookieReducer,
  vendorFileReducer,
  agreementFileReducer,
  costViewReducer,
  errorReducer,
  filesLogReducer,
  successReducer,
  userReducer,
  reportsLogReducer,
  usersReducer,
  secretsReducer,
  userManagementReducer: combineReducers({
    userAssociationReducer,
    userGroupReducer,
    vendorAssociationFileImportReducer,
  }),
  userProfileReducer,
  enterpriseCostReducer,
  agreementDataReducer,
  agreementSearchDataReducer,
  utilitiesReducer,
  vendorReducer: combineReducers({
    vendorDataReducer,
    vendorFilterDataReducer,
  }),
  reportReducer: combineReducers({
    costAuditDataReducer,
    adhocCostDataReducer,
    reportSupplementaryDataReducer,
  }),
  workspaceReducer: combineReducers({
    contactUsReducer,
    helpTopicsReducer,
    recentActivityReducer,
    requestDataReducer,
    workspaceSearchReducer,
  }),
  formulaGroupReducer,
  vendorBasesReducer,
  businessCentersReducer,
  sasFDDataReducer,
  massItemUploadReducer,
  searchDataReducer,
  costImpactTermDataReducer,
  priceModuleReducer: combineReducers({
    priceModuleDataReducer,
    priceModuleFilterReducer,
  }),
  segmentDataReducer,
});

export default rootReducer;
